import { render, staticRenderFns } from "./tenant-settings.vue?vue&type=template&id=0470f4d2&scoped=true&"
import script from "./tenant-settings.vue?vue&type=script&lang=js&"
export * from "./tenant-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470f4d2",
  null
  
)

export default component.exports